// @ts-check
import React from 'react';
import {
  TextField,
  TextAreaField,
  CheckboxGroupField,
  RadioGroupField,
  PlainSelectField,
  SelectField,
  ICD10Field,
  ToothSelectorField,
  SignatureField,
} from 'shared/containers/portal_layout/HForm';
import { formFieldName } from 'utils/questionnaireUtils';

const COMPONENT_MAPPINGS = {
  text_input: TextField,
  text_area: TextAreaField,
  checkbox: CheckboxGroupField,
  radio: RadioGroupField,
  select: PlainSelectField,
  fancy_select: SelectField,
  icd_10_input: ICD10Field,
  tooth_selector: ToothSelectorField,
  signature: SignatureField,
};

/** @typedef {{
  text_input: React.ComponentClass | React.SFC,
  text_area: React.ComponentClass | React.SFC,
  checkbox: React.ComponentClass | React.SFC,
  radio: React.ComponentClass | React.SFC,
  select: React.ComponentClass | React.SFC,
  fancy_select: React.ComponentClass | React.SFC,
  icd_10_input: React.ComponentClass | React.SFC
}} QuestionComponentMappingType */

/**
 * @param {QuestionComponentMappingType} componentMappings
 */
export function componentForQuestionFactory(componentMappings) {
  return (sectionTitle, question) => {
    const component = componentMappings[question.elementType];
    if (!component) return null; // TODO: should probably send some kind of sentry notification when this happens, but still fail gracefully
    const name = formFieldName(sectionTitle, question.prompt);
    const props = {
      key: name,
      name,
      label: question.prompt,
      id: name,
    };
    if (question.answerOptions && question.answerOptions.length > 0) {
      props.options = question.answerOptions.map(opt => ({ value: opt.value, label: opt.value }));
    }
    return React.createElement(component, props);
  };
}

export default componentForQuestionFactory(COMPONENT_MAPPINGS);
